import { Radio } from '@mantine/core';
import { DatePickerInput, DateValue } from '@mantine/dates';
import { Calendar, CalendarClock } from 'lucide-react';

import Icon from '@/components/Icon.tsx';

import { SeriesPlanningMode } from '@/models/appointment/Appointment.ts';

import { dayjs } from '@/utils/dayjsSetup.ts';

interface Props {
    planningMode: SeriesPlanningMode;
    onPlanningModeChange: (mode: SeriesPlanningMode) => void;
    startDate: string;
    onStartDateChange: (date: string) => void;
    disabled?: boolean;
}

export const SeriesPlanningSelector = ({
    planningMode,
    onPlanningModeChange,
    startDate,
    onStartDateChange,
    disabled = false,
}: Props) => {
    const handleStartDateChange = (value: DateValue): void => {
        onStartDateChange(dayjs(value ?? undefined).format('YYYY-MM-DD'));
    };

    return (
        <Radio.Group
            label="Planung"
            value={planningMode}
            onChange={(value) => onPlanningModeChange(value as SeriesPlanningMode)}
        >
            <div className="mt-1 flex items-start gap-3">
                <Radio.Card
                    value={SeriesPlanningMode.AUTO}
                    disabled={disabled}
                    className="flex-1 cursor-pointer rounded-lg border bg-white p-3 data-[checked]:border-primary"
                >
                    <div className="flex items-center gap-3">
                        <Radio.Indicator />
                        <Icon icon={CalendarClock} size="size-4" />
                        <span className="text-sm font-medium">Auto-Vorschlag</span>
                    </div>
                </Radio.Card>

                <div className="flex flex-1 flex-col gap-2">
                    <Radio.Card
                        value={SeriesPlanningMode.START_DATE}
                        disabled={disabled}
                        className="w-full cursor-pointer rounded-lg border bg-white p-3 data-[checked]:border-primary"
                    >
                        <div className="flex items-center gap-3">
                            <Radio.Indicator />
                            <Icon icon={Calendar} size="size-4" />
                            <span className="text-sm font-medium">Startdatum</span>
                        </div>
                    </Radio.Card>
                    {planningMode === SeriesPlanningMode.START_DATE && (
                        <DatePickerInput
                            locale="de"
                            placeholder="Datum wählen"
                            minDate={dayjs().toDate()}
                            disabled={disabled}
                            value={startDate ? dayjs(startDate).toDate() : undefined}
                            onChange={handleStartDateChange}
                        />
                    )}
                </div>
            </div>
        </Radio.Group>
    );
};
